module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [(!_vm.requested) ? _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Hallo!")]), _vm._m(0)]) : _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Gelukt!")]), _c('p', [_vm._v("Activeer eerst je account om verder te gaan.")])]), (!_vm.requested) ? _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('code')
    }
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Uitnodigingscode")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "id": "code",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), (_vm.forgot) ? _c('div', [_c('router-link', {
    staticClass: "to-forgot",
    attrs: {
      "to": {
        name: 'forgot'
      }
    }
  }, [_vm._v("Wachtwoord vergeten?")])], 1) : _vm._e(), _c('primary-button', {
    attrs: {
      "link": {
        name: 'root'
      },
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Registreren")])], 1)]), _c('div', {
    staticClass: "login__auth-other"
  }, [_vm._v("\n                Heb je al een werkmap? "), _c('router-link', {
    staticClass: "to-login",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")])], 1)]) : _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('p', [_vm._v("Er is een mailtje verstuurd naar: "), _c('strong', [_vm._v(_vm._s(_vm.email))])]), _c('p'), _c('p', [_vm._v("Bekijk je mail en klik op de activatie knop om door te gaan.")]), _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Geen mailtje ontvangen?")]), _vm._v(" Check eerst je "), _c('em', [_vm._v("spam")]), _vm._v(" map, controleer of je je e-mailadres goed hebt ingevuld en "), _c('a', {
    staticClass: "to-register",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("probeer het opnieuw")]), _vm._v(".")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', [_vm._v("Vul je gegevens in om jouw eigen werkmap aan te maken."), _c('br'), _c('strong', [_vm._v("Let op:")]), _vm._v(" je kunt alleen registreren met jouw uitnodigingscode.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec0e4ee","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/auth/Register.vue
// module id = lqEK
// module chunks = 1